/**
 * @generated SignedSource<<36dfaaec0a0a43f02e5be0172eb33b22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterPassedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type contentSubmissionNavigation_RestartContentNodeAfterPassedMutation$variables = {
  input: RestartContentNodeAfterPassedInput;
};
export type contentSubmissionNavigation_RestartContentNodeAfterPassedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterPassed: {
      readonly clientMutationId: string | null;
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type contentSubmissionNavigation_RestartContentNodeAfterPassedMutation = {
  response: contentSubmissionNavigation_RestartContentNodeAfterPassedMutation$data;
  variables: contentSubmissionNavigation_RestartContentNodeAfterPassedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterPassedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterPassed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contentSubmissionNavigation_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentSubmissionNavigation_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef25c6ef6b77272a7c2b5e31d8383336",
    "id": null,
    "metadata": {},
    "name": "contentSubmissionNavigation_RestartContentNodeAfterPassedMutation",
    "operationKind": "mutation",
    "text": "mutation contentSubmissionNavigation_RestartContentNodeAfterPassedMutation(\n  $input: RestartContentNodeAfterPassedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterPassed(input: $input) {\n      clientMutationId\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "631f65b41aedcef795e31f212eaaf483";

export default node;
